<ng-container uiSnackbarRef></ng-container>
